<script>
import { Button } from "element-ui";

export default {
  name: "elButton",
  mixins: [Button],
  components: {
    Button
  },
  props: {
    buttonCode: {
      type: String
    }
  },
  mounted() {
    if (this.buttonCode != undefined) {
      let path = window.location.href;

      const numberSign = path.indexOf("#");
      const parameter = path.indexOf("?");

      if (parameter != -1) {
        //地址上带参
        path = path.substring(numberSign + 1, parameter);
      } else {
        path = path.substring(numberSign + 1);
      }

      if (path != null) {
        this.$el.style.display = "none";
      }

      this.traverseTree(path, JSON.parse(sessionStorage.getItem("loginData")));
    }
  },
  methods: {
    traverseTree(path, data) {
      if (data != null) {
        for (let index = 0; index < data.length; index++) {
          const menu = data[index];
          if (menu.url === path) {
            for (let index = 0; index < menu.buttonList.length; index++) {
              const button = menu.buttonList[index];
              if (button.buttonCode === this.buttonCode) {
                this.$el.style.display = "";
              }
            }
          } else {
            this.traverseTree(path, menu.children);
          }
        }
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/defaultElement/button.vue